module.exports = __webpack_public_path__ + "static/media/480.65b7a505.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-construction/dark/480.png
// module id = 1968
// module chunks = 2